import { lazy } from 'react';

const OrganisationSituationContainer = lazy(
  () => import('../containers/OrganisationSituationContainer'),
);

const OrganisationSituationRoute = () => <OrganisationSituationContainer />;

export default OrganisationSituationRoute;
